import { createReducer, on } from '@ngrx/store'

import * as ProfileAdminActions from './profile-admin.actions'

export const PROFILE_ADMIN_FEATURE_KEY = 'profileAdmin'

export interface ProfileAdminState {
  addPersonContext?: {
    orgId: number
    personaIds?: string[]
    affiliatePermissionOrganization?: string
    triggerId?: string
    defaultNoGrant?: boolean
    title?: string
  }
  removeAccessContext?: { orgId: number; personaIds: string[]; triggerId?: string }
  editRolesPermissionsContext?: { orgId: number; personaIds: string[]; affiliatePermissionOrganization?: string; triggerId?: string }
  sendMessageContext?: { orgId: number; personaIds: string[]; personaNames?: string[]; triggerId?: string }
  addToGroupContext?: { orgId: number; personaIds: string[]; groupId?: string; triggerId?: string }
  buyMembershipContext?: {
    orgId: number
    personaIds: string[]
    membershipType?: string
    membershipDefinitionId?: string
    availableMembershipDefinitionIds?: string[]
    triggerId?: string
  }
}

export const initialState: ProfileAdminState = {
  addPersonContext: undefined,
  removeAccessContext: undefined,
  editRolesPermissionsContext: undefined,
  sendMessageContext: undefined,
  addToGroupContext: undefined,
  buyMembershipContext: undefined,
}

export const profileAdminReducer = createReducer(
  initialState,
  on(ProfileAdminActions.resetState, () => ({ ...initialState })),
  on(ProfileAdminActions.addPerson, (state, { type, ...context }) => ({
    ...state,
    addPersonContext: { ...context },
  })),
  on(ProfileAdminActions.removeAccess, (state, { type, ...context }) => ({
    ...state,
    removeAccessContext: { ...context },
  })),
  on(ProfileAdminActions.editRolesPermissions, (state, { type, ...context }) => ({
    ...state,
    editRolesPermissionsContext: { ...context },
  })),
  on(ProfileAdminActions.sendMessage, (state, { type, ...context }) => ({
    ...state,
    sendMessageContext: { ...context },
  })),
  on(ProfileAdminActions.addToGroup, (state, { type, ...context }) => ({
    ...state,
    addToGroupContext: { ...context },
  })),
  on(ProfileAdminActions.buyMembership, (state, { type, ...context }) => ({
    ...state,
    buyMembershipContext: { ...context },
  }))
)
